import { createClient } from '@supabase/supabase-js';

// Configuração do Supabase - REQUER variáveis de ambiente
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Validação das configurações
if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Erro: Configurações do Supabase não encontradas');
    throw new Error('Supabase URL e/ou Anon Key não estão configurados');
}

// Criação do cliente Supabase
let supabase;
try {
    supabase = createClient(supabaseUrl, supabaseAnonKey);
} catch (error) {
    console.error('Erro ao criar cliente Supabase:', error);
    throw new Error('Falha na inicialização do Supabase');
}

export { supabase };

